// extracted by mini-css-extract-plugin
export default {"celdaOrdenable":"CeldaOrdenable_celdaOrdenable__R6-FQ","icono":"CeldaOrdenable_icono__kHgHr"};